export const environment = {
  production: true,
  baseUrl: 'https://api.dev.livingmeaningfully.ca',
  googleClientId: '715437575479-r7lovegacbm4r74if42bfub7po120anb.apps.googleusercontent.com',
  facebookClientId: '1128172314362694',
  mailingAddress: 'lm_subscribers_demo@sandbox33c3d16ba71b4904b441ca6bd1f68aa3.mailgun.org',
  socketUrl: 'wss://api.dev.livingmeaningfully.ca/ws/connect/?Token:',
  chatSocketUrl: 'wss://api.dev.livingmeaningfully.ca/ws/chat/',
  postSocketUrl: 'wss://api.dev.livingmeaningfully.ca/ws/post/',
  tribeDomain: 'https://tribe.livingmeaningfully.ca',
};
